import * as React from "react";

import { IconTypes, IconSizes } from "../types";
import styled from "styled-components";
import { themeValues } from "../theme";
import cn from "classnames";

const IconComponent = styled.i`
  display: inline-block;

  &.xlarge {
    width: ${themeValues.iconSize.xlarge};
    height: ${themeValues.iconSize.xlarge};
    &::before {
      font-size: ${themeValues.iconSize.xlarge};
    }
  }
  &.large {
    width: ${themeValues.iconSize.large};
    height: ${themeValues.iconSize.large};
    &::before {
      font-size: ${themeValues.iconSize.large};
    }
  }
  &.medium {
    width: ${themeValues.iconSize.medium};
    height: ${themeValues.iconSize.medium};
    &::before {
      font-size: ${themeValues.iconSize.medium};
    }
  }
  &.small {
    width: ${themeValues.iconSize.small};
    height: ${themeValues.iconSize.small};
    &::before {
      font-size: ${themeValues.iconSize.small};
    }
  }
  &.xsmall {
    width: ${themeValues.iconSize.xsmall};
    height: ${themeValues.iconSize.xsmall};
    &::before {
      font-size: ${themeValues.iconSize.xsmall};
    }
  }

  &::before {
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

interface IIconProps { // TODO: sizes, etc.
  children?: JSX.Element;
  size?: IconSizes | number;
  glyph?: IconTypes;
  className?: string
}

export function Icon({ glyph, children, size = "medium", className }: IIconProps): JSX.Element {
  if (Number.isInteger(size)) {
    return <IconComponent className={cn(glyph, className)} style={{ fontSize: size }}>
      {children}
    </IconComponent>;
  }
  return <IconComponent className={cn(glyph, size, className)}>
    {children}
  </IconComponent>;
}